import { render, staticRenderFns } from "./VehicleRestorePolicy.vue?vue&type=template&id=52e2ec31&scoped=true&"
import script from "./VehicleRestorePolicy.vue?vue&type=script&lang=js&"
export * from "./VehicleRestorePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e2ec31",
  null
  
)

export default component.exports